import { SaveOutlined } from '@ant-design/icons';
import { Col, Form, Input, message, Modal, Row } from 'antd';
import React, { useState } from 'react';
import ZTable, { ITableRef, IColumnType } from '@/components/ZTable';
import { useTranslation } from 'react-i18next';
import { ModalWidth, VALIDATE_REQUIRED } from '@/config';
import CreateBtn from '@/components/app/CreateBtn';
import { BusBrandDto } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { defaultApiErrorHandle } from '@/helpers/errorHandler';

const columns: IColumnType<BusBrandDto>[] = [
  {
    title: 'Brand Name',
    dataIndex: 'brandName',
  },

  {
    title: 'Brand Symbol',
    dataIndex: 'brandSymbol',
  },
  {
    title: 'Brand Country',
    dataIndex: 'brandCountry',
  },
];

const BusBrandTab = () => {
  const { t } = useTranslation();
  const zTb = React.useRef<ITableRef>();
  const [form] = Form.useForm();
  const [formVisible, setFormVisible] = useState(false);
  const [isNewForm, setIsNewForm] = useState(false);
  const [loading, setLoading] = useState(false);

  const createEntity = values => {
    setLoading(true);
    apiSdk.BusBrandService.create({ body: values })
      .then(response => {
        if (response?.success) {
          setFormVisible(false);
          zTb.current?.reload();
        } else {
          if (response.message) {
            message.error(t(response.message || ''));
          }
        }
      })
      .catch(defaultApiErrorHandle)
      .finally(() => {
        setLoading(false);
      });
  };
  const updateEntity = values => {
    setLoading(true);
    apiSdk.BusBrandService.update({ body: values })
      .then(response => {
        if (response?.success) {
          setFormVisible(false);
          zTb.current?.reload();
        } else {
          if (response.message) {
            message.error(t(response.message || ''));
          }
        }
      })
      .catch(defaultApiErrorHandle)
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <ZTable
        columns={columns}
        primaryKey="id"
        tableRef={zTb}
        url="/fleets/bus-brands/get-bus-brands"
        bordered
        order_by="createdOn"
        order_by_asc={true}
        allowEdit={true}
        onEdit={record => {
          setIsNewForm(false);
          setFormVisible(true);
          form.setFieldsValue({
            ...record,
          });
        }}
        allowDelete={true}
        delete_url="/fleets/bus-brands/delete"
        searchBtnAlignLeft
        extraBtns={
          <CreateBtn
            onClick={() => {
              setIsNewForm(true);
              setFormVisible(true);
              form.resetFields();
            }}
          />
        }
      ></ZTable>
      {formVisible ? (
        <Modal
          open={formVisible}
          maskClosable={false}
          width={ModalWidth.small}
          className="nta-custom-form"
          title={isNewForm ? 'New bus brand' : 'Update bus brand'}
          forceRender={true}
          okText={t('save')}
          cancelText={t('cancel')}
          okButtonProps={{ icon: <SaveOutlined />, className: 'save-btn', loading: loading }}
          onCancel={() => {
            form.resetFields();
            setFormVisible(false);
          }}
          onOk={() => {
            form
              .validateFields()
              .then(values => {
                if (values.id) {
                  updateEntity(values);
                } else {
                  createEntity(values);
                }
              })
              .catch(info => {});
          }}
        >
          <Form form={form} size="middle" layout="horizontal" labelAlign="right" labelCol={{ md: 10 }}>
            <Form.Item name="id" className="hidden">
              <Input type="hidden" />
            </Form.Item>
            <Row gutter={6}>
              <Col md={24}>
                <Form.Item label={'Brand Name'} name="brandName" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
                  <Input />
                </Form.Item>
                <Form.Item label={'Brand Symbol'} name="brandSymbol">
                  <Input />
                </Form.Item>
                <Form.Item label={'Brand Country'} name="brandCountry">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      ) : null}
    </div>
  );
};
export default BusBrandTab;
